import React, { Component } from "react";
import moment from "moment";

import { Div, H5, Span } from "@driftt/tide-core";
import { Icon } from '@driftt/tide-icons'

const MEETING_SOURCE_TO_ENGLISH = {
  "CALENDAR_DROP": " from a calendar drop",
  "EMAIL_DROP": " from an email",
  "PROFILE_DROP": " from a profile link",
  "RESCHEDULE": " from rescheduling a meeting",
  "SEQUENCE_DROP": " from a sequence drop",
  "NONE": "",
  "FALLBACK_EMAIL": " from a fallback email"
};

class MeetingBookedEvent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      eventInformation: null
    };
  }

  componentDidMount() {
    this.renderEventInformation();
  }

  renderEventInformation = () => {
    const { event } = this.props;

    const stringSource = event.body.attributes.event.meetingSource;

    let validEventKey;

    const isValid = Object.keys(MEETING_SOURCE_TO_ENGLISH).some(eventToTest => {

      if (stringSource.includes(eventToTest)) {
        validEventKey = eventToTest;
        return true;
      } else {
        return false;
      }
    });

    this.setState({
      eventInformation: isValid
        ? ` booked a meeting ${MEETING_SOURCE_TO_ENGLISH[validEventKey]}`
        : ` booked a meeting`
    });
  };

  render() {
    const { eventInformation } = this.state;
    const { event, name } = this.props;
    return (
      <Div className="contact-event--container">
        <Div className="contact-event--icon-long">
          <Icon name="calendar-check" width={15} />
        </Div>
        <Div className="contact-event--event-description">
          <H5>
            {name} {!!eventInformation && eventInformation}
          </H5>
          <Span>{moment(event.createdAt).format("MM/DD/YYYY hh:mm A")}</Span>
          <Div className="contact-event--meeting-details">
            {event.body.attributes.event.meetingType}
            <br></br>
            {moment(event.body.attributes.event.slotStart).format("hh:mm ")} to
            {moment(event.body.attributes.event.slotEnd).format(" hh:mm A MM/DD/YYYY")}
          </Div>
        </Div>
      </Div>
    );
  }
}

export default MeetingBookedEvent;
